<template>
  <template  v-if="!isLoadingId && !isLoading">
  <template v-if="form && form.domain">
    <link rel="stylesheet"  :href="(form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001/app_dev.php' : form.domain) + '/forms/css/' + form.route">
  </template>
  <SettingsComponent v-if="modeConfig === 'config'"></SettingsComponent>
  <FormComponent v-if="!modeConfig && embed" />
  <q-layout v-if="!modeConfig && !embed" view="hHh Lpr lff" >

    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn icon="s_menu" dense flat round @click="toggleLeftDrawer" />

        <q-toolbar-title>
<!--          <q-avatar>-->
<!--            <img src="https://cdn.quasar.dev/logo-v2/svg/logo-mono-white.svg">-->
<!--          </q-avatar>-->
          {{form.name}}
        </q-toolbar-title>
        <q-space />

        <q-btn v-if="user && user.authenticated"  class="text-transform-none" icon="s_account_circle" flat round dense :label="user.first_name ? user.first_name + ' ' + user.last_name : user.email">
          <q-menu>
            <q-list icon="s_account_circle" style="min-width: 100px">
              <q-item icon="s_list" @click="this.$router.push('/forms')" clickable v-close-popup>
                <q-item-section class="text-transform-none">Dashboard</q-item-section>
              </q-item>
              <q-item icon="s_logout" @click="this.$router.push('/logout')" clickable v-close-popup>
                <q-item-section  class="text-transform-none">Logout</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </q-toolbar>
    </q-header>

    <q-drawer
        v-model="leftDrawerOpen"
        show-if-above
        :width="250"
        :breakpoint="500"
        bordered

    >
<!--      class="bg-grey-3" class="fit"-->
      <q-scroll-area
                     style="height: calc(100% - 150px); margin-top: 150px; "
      >
        <q-list v-if="form">

          <template v-for="(screen, index) in form.screens" :key="index">
            <template v-if="(!screen.hide_in_sidebar && screensVisibility[screen.id]) || debug">
              <q-item
                  v-if="screen.separator_in_menu"
                  clickable  v-ripple :class="{ disabled: !screensVisibility[screen.id] }"

                       @click="activate(index)"
              >
                <q-item-section v-if="screen.icon" avatar>
                  <q-icon :name="'s_'+screen.icon"></q-icon>
                </q-item-section>
                <q-item-section>

                  <q-item-label>{{ screen.name_of_screen_when_splitted }}</q-item-label>
                </q-item-section>

              </q-item>
            <q-separator v-if="screen.separator_in_menu"></q-separator>

            <q-item  :active="index == activeScreen" clickable  v-ripple :class="{ disabled: !screensVisibility[screen.id] }"

            @click="activate(index)"
            >
              <q-item-section v-if="screen.icon && !screen.separator_in_menu" avatar>
                <q-icon :name="'s_'+screen.icon"></q-icon>
              </q-item-section>
              <q-item-section>

                <q-item-label>{{ screen.name }}</q-item-label>
              </q-item-section>

            </q-item>

<!--            <q-separator v-if="index == activeScreen"></q-separator>-->
            </template>
          </template>

        </q-list>
      </q-scroll-area>
      <q-img v-if="form && form.domain" class="absolute-top" src="https://cdn.quasar.dev/img/material.png" style="height: 150px">
        <div class="absolute-bottom bg-transparent q-pa-md">
          <div class="text-center">
          <q-img
              :src="(form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001' : form.domain) + form.logo"
              class="q-mb-sm" fit="contain" spinner-color="blue" style="height: 100px; max-width: 100%"
            />
          </div>
          <div class="text-weight-bold">{{site.company}}</div>
          <div>{{site.email}}</div>
        </div>

      </q-img>
    </q-drawer>
    <q-page-container>
      <q-page padding>
<!--        <div v-if="debug" class="q-mx-auto" style="max-width: 1200px">-->
<!--        <q-toggle v-model="modeConfig" label="Config mode"-->
<!--                  debounce="500"-->
<!--        />-->
<!--        </div>-->
      <FormComponent />
      </q-page>
    </q-page-container>
  </q-layout>
  </template>
</template>

<script>
import FormComponent from './components/FormComponent.vue'
import SettingsComponent from './components/SettingsComponent.vue'
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import {
  fetchEnv, getFieldByFieldType,
  getFieldByType,
  getFieldsVisibilityFromForm,
  getScreensVisibilityFromForm,
  getStartingFieldValuesFromForm,
  theme
} from "@/helpers/form";
import {app} from './main'
import {VueReCaptcha} from 'vue-recaptcha-v3'
import favicon from "favicon.js"
import {debounce, Loading, Notify} from "quasar";
import {diff} from 'deep-object-diff';
import {refreshLostFormToken, setLostFormToken} from "@/helpers/lostForm";
import {isReCaptchaLoaded, setReCaptchaIsLoaded} from "@/helpers/recaptcha";

export default {
  name: 'LayoutDefault',
  props: {
    mode_config: null
  },
  components: {
    FormComponent,
    SettingsComponent
  },
  data () {
    return{
      leftDrawerOpen : false,
      rightDrawerOpen : false,
      embed: false,
      modeConfig: false,
      debouncedGaFieldEvents: {},
      isLoadingId: true
    }
  },
  methods: {
    ...mapActions({
      getForm: 'settings/list/default',
      updateFieldValue: 'values/list/updateFieldValue',
      updateFieldValueByFieldType: 'values/list/updateFieldValueByFieldType',
      setFieldValues: 'values/list/setFieldValues',
      setFieldVisibility: 'values/list/setFieldVisibility',
      setScreenVisibility: 'values/list/setScreenVisibility',
      enableDebug: 'values/list/enableDebug',
      setLoanType: 'values/list/setLoanType',
      setPassedParams: 'values/list/setPassedParams',
      fieldsVisibilityVersionUp: 'values/list/fieldsVisibilityVersionUp',
      screensVisibilityVersionUp: 'values/list/screensVisibilityVersionUp',
      setScreen: 'values/list/setScreen'
    }),
    activate(index)
    {
      if(this.debug && this.screensVisibility[this.form.screens[index].id]) {
        this.setScreen({'screen' : index});
      }
    }    ,
    initResize () {
      // create an Observer instance
      const resizeObserver = new ResizeObserver(() => {
            //console.log('Body height changed:', entries[0].target.clientHeight);
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            const message = JSON.stringify({
              message: 'resize',
              id: id,
              scrollHeight: document.body.scrollHeight
            });
            window.parent.postMessage(message, '*');
          }
      )
      resizeObserver.observe(document.body);
    },
    updateFieldValueByFieldTypeWithCheck(form, type, fieldValue) {
      const loanPurposeField = getFieldByFieldType(form, type);
      if(loanPurposeField !== null) {
        this.updateFieldValueByFieldType({form: form, type: type, fieldValue: fieldValue});
      } else {
        this.updateFieldValue({fieldSettings: {id: type}, fieldValue: fieldValue});
      }
    },
    passedParamsPrefill() {
      if(this.passed_params) {
        this.updateFieldValue({fieldSettings: {id: "passed_params"}, fieldValue: this.passed_params});
      }
    },
    loanTypePrefill() {
        // Loan Type prefill
      if(this.loan_type) {
        this.updateFieldValue({fieldSettings: {id: "loan_type_prefill"}, fieldValue: this.loan_type});
        switch (this.loan_type) {
            /*
             "Purchase" => 0,
            "Refinance" => 1,
            'Home Equity' => 2,
            'Home Improvement' => 3
             */
          case "purchase":
          {
            this.updateFieldValueByFieldTypeWithCheck(this.form, 'loan.purpose', "Purchase");
          } break;
          case "refinance":
          {
            this.updateFieldValueByFieldTypeWithCheck(this.form, 'loan.purpose', "Refinance");
          } break;
          case "cash-out":
          {
            this.updateFieldValueByFieldTypeWithCheck(this.form, 'loan.purpose', "Refinance");
            this.updateFieldValueByFieldTypeWithCheck(this.form, 'loan.refinance.purpose', "Cash-Out Other");
          } break;
          case "home-equity":
          {
            this.updateFieldValueByFieldTypeWithCheck(this.form, 'loan.purpose', "Refinance");
          } break;
        }
      }
    },
    initPrefill () {
      window.addEventListener('message', (e) => {
        let data = {};
        try {
          data = JSON.parse(e.data);
          const channel = data.message;
          if (channel === 'prefill') {
            const key = data.key;
            const value = data.value;

            const field = getFieldByType(this.form, key);
            if(field !== null) {
              this.updateFieldValue({fieldSettings: field, fieldValue: value})
            }
          }
          if (channel === 'prefill_multi_set_screen') {
            const screen_key = data.key;
            const value = data.value;

            for(let i in value) {
              const field = getFieldByType(this.form, i);
              if(field !== null) {
                this.updateFieldValue({fieldSettings: field, fieldValue: value[i]})
              }
            }
            this.setScreen({'screen' : screen_key});
          }

          if (channel === 'prefill_loan_type') {
            const value = data.value;
            // this.enableDebug();
            this.setLoanType({type:value});
            this.loanTypePrefill();

          }

          if (channel === 'passed_params') {
            const value = data.value;
            this.setPassedParams({passed_params:value});
            this.passedParamsPrefill();

          }
        } catch (e) {
          return e;
        }
      });
    },
    toggleLeftDrawer () {
      this.leftDrawerOpen = !this.leftDrawerOpen
    },
    initGTag() {
      if(this.form.gtag_url) {
        const script = document.createElement('script');
        script.onload = () => {
          if(this.form.gtag) {
            try {
              const scriptGtag = document.createElement('script');
              scriptGtag.type = 'text/javascript';
              const domain = (this.form.domain === 'https://mortgageware.dev' ? 'http://localhost:9001/app_dev.php' : this.form.domain);
              scriptGtag.src = domain + '/forms/gtag/' + this.form.route;
              document.head.appendChild(scriptGtag);

              scriptGtag.onload = () => {
                try {
                  // eslint-disable-next-line no-undef
                  gtag('event', 'form_view', {'event_category': 'form_field', 'event_label': this.form.name});
                } catch (e) {
                  console.log(e);
                }
              }
              if(this.debug) {
                Notify.create('Gtag init executed');
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
        script.type = 'text/javascript';
        script.src = this.form.gtag_url;
        document.head.appendChild(script);
      }
    }
  },
  computed: {
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      activeScreen: "activeScreen",
      debug: "debug",
      loan_type: "loan_type",
      passed_params: "passed_params"
    }),
    ...mapFields('settings/list', {
      error: 'error',
      form: 'form',
      settings: 'settings',
      isLoading: 'isLoading',
      fieldsById: "fieldsById",
      user: 'user',
      site: 'site'
    }),
  },
  mounted() {
    this.initResize();
    const urlParams = new URLSearchParams(window.location.search);
    const formName = urlParams.get('form');
    const debugName = urlParams.get('debug');
    const embed = urlParams.get('embed');
    const mode = urlParams.get('mode');
    if(mode === 'config' || this.mode_config === true) {
      this.modeConfig = 'config';
    }
    if(formName) {
      this.getForm({ form: formName});
    }
    if(debugName) {
      this.enableDebug();
    }
    if(embed) {
      this.embed = true;
      document.body.classList.add('embed-body');
    }
    this.initPrefill();
    //this.$router.push('/login')
  },
  watch: {
    // screensVisibility: function() {
    //   console.log('screens Visibility changed');
    // },
    // user: function(newVal) {
    //   if(newVal && newVal.email) {
    //     console.log(newVal.email);
    //     var key = 'borrower.email';
    //     const field = getFieldByType(this.form, key);
    //     var current_email = this.fieldValues[key];
    //     if(field !== null && (!current_email)) {
    //       this.updateFieldValue({fieldSettings: field, fieldValue: newVal.email})
    //     }
    //   }
    // },
    fieldsVisibility: function() {
      const newScreenVisibility = getScreensVisibilityFromForm(this.form, this.fieldsVisibility);
      const a1 = JSON.stringify(newScreenVisibility);
      const a2 = JSON.stringify(this.screensVisibility);
      if(a1 !== a2) {
        this.setScreenVisibility(
            newScreenVisibility
        );
      }
      this.screensVisibilityVersionUp();
    },
    fieldValues: function(newVal, oldVal) {


      const newFieldVisibility =  getFieldsVisibilityFromForm(this.form, this.fieldValues);
      const a1 = JSON.stringify(newFieldVisibility);
      const a2 = JSON.stringify(this.fieldsVisibility);
      if(a1 !== a2) {
        this.setFieldVisibility(
            newFieldVisibility
        );
        this.fieldsVisibilityVersionUp();
      } else {
        this.fieldsVisibilityVersionUp();
        this.screensVisibilityVersionUp();
      }

      const changes = diff(oldVal, newVal);
      if(this.form.send_ga_field_events) {
        for (let key in changes) {
          if(changes[key]) {
            let field = this.fieldsById[key];
            if(!this.debouncedGaFieldEvents[key]) {
              this.debouncedGaFieldEvents[key] = debounce((field) => {
                //console.log(field.field_gtag_label + ' ' + field);
                if(typeof gtag  === "function") {
                  // eslint-disable-next-line no-undef
                  gtag('event', 'form_field', {'event_category': 'form_field', 'event_label': field.field_gtag_label});
                }
              }, 3000);
            }
            this.debouncedGaFieldEvents[key](field, changes[key]);
          }
        }
      }

    },
    form: function(form) {

      if(this.form.favicon) {
        favicon.change(this.form.favicon, this.form.name);
      } else {
        favicon.change(null, this.form.name);
      }
      if(!isReCaptchaLoaded) {
        app.use(VueReCaptcha, {siteKey: form.sitekey});
        setReCaptchaIsLoaded();
      }

      this.setFieldValues(
          getStartingFieldValuesFromForm(form)
      );



      // this.setFieldValues(
      //     { "28": "alex", "29": "alexey.yegorov@webmaxco.com", "30": "2532423423", "31": "test", "32": "message text", "33": "243234234", "34": "Purchase", "100": null, "101": "Alex Yegorov" }
      // );
      if(this.$route.params.id) {
        setLostFormToken(this.$route.params.id);
        Loading.show({group: 'form'});
        fetchEnv('/front/api/v1/forms/' + this.$route.params.id, {

        })
            .then(
                (response) => {
                  if(response.authenticated === undefined || !response.authenticated) {
                    let errorBlock = '';
                    for(let key in response.error) {
                      errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                    }
                    Notify.create(  //'Something went wrong');
                        {
                          message: '<p><em>Something went wrong: you are not authenticated</em></p>' + errorBlock,
                          html: true,
                          timeout:5000
                        });
                    this.isLoadingId = false;
                    Loading.hide('form');
                    //if(response.form.require_login === true) {
                      this.$router.push('/signup');
                    //}
                    //console.log(response);
                  } else {
                    //Notify.create('Forms loaded');
                    if(response.form !== undefined && response.form
                      && response.form.values !== undefined && response.form.values
                    ) {

                      this.setFieldValues(
                          response.form.values
                      );
                      this.setScreen({'screen' : response.form.activeScreen});

                    }
                    this.isLoadingId = false;
                    Loading.hide('form');
                    //this.$router.push('/forms');

                  }
                })
            .catch(error => console.log(error));
      } else {

        if(this.user && this.user.email) {
          var key = 'borrower.email';
          const field = getFieldByType(this.form, key);
          var current_email = this.fieldValues[key];
          if(field !== null && (!current_email)) {
            this.updateFieldValue({fieldSettings: field, fieldValue: this.user.email})
          }
        }
        if(this.user && this.user.first_name) {
          var key_bf = 'borrower.first_name';
          const field_bf = getFieldByType(this.form, key_bf);
          var first_name = this.fieldValues[key_bf];
          if(field_bf !== null && (!first_name)) {
            this.updateFieldValue({fieldSettings: field_bf, fieldValue: this.user.first_name})
          }
        }
        if(this.user && this.user.last_name) {
          var key_bl = 'borrower.last_name';
          const field_bl = getFieldByType(this.form, key_bl);
          var last_name = this.fieldValues[key_bl];
          if(field_bl !== null && (!last_name)) {
            this.updateFieldValue({fieldSettings: field_bl, fieldValue: this.user.last_name})
          }
        }

        this.isLoadingId = false;
        this.setScreen({'screen' : 0});
        refreshLostFormToken(this.form);

        this.loanTypePrefill();
        this.passedParamsPrefill();
      }

      this.initGTag();

    },
    settings: function(settings) {
      theme(settings);
    }
  },
  setup () {
    return {

    }
  }
}
</script>
<style scoped>
.text-transform-none {
  text-transform: none;
}
</style>
<style>
  .embed-body {
    overflow-y: hidden !important;
  }
  .grecaptcha-badge {
    visibility: hidden !important;
  }
  :root {
    --q-fb-next-colors-primary: var(--q-primary);
    --q-fb-next-colors-border:var(--q-primary);;
    --q-fb-next-colors-hover: var(--q-primary);;
    --q-fb-next-colors-hover_border: var(--q-primary);;
    --q-fb-next-colors-text: #fff;
    --q-fb-next-colors-text_hover: #fff;

    --q-fb-back-colors-primary: var(--q-primary);
    --q-fb-back-colors-border:var(--q-primary);;
    --q-fb-back-colors-hover: var(--q-primary);;
    --q-fb-back-colors-hover_border: var(--q-primary);;
    --q-fb-back-colors-text: #fff;
    --q-fb-back-colors-text_hover: #fff;

    --q-fb-button-colors-primary: var(--q-primary);
    --q-fb-button-colors-active: var(--q-secondary);
    --q-fb-button-colors-border:var(--q-primary);;
    --q-fb-button-colors-hover: var(--q-primary);;
    --q-fb-button-colors-hover_border: var(--q-primary);;
    --q-fb-button-colors-text: #fff;
    --q-fb-button-colors-text_hover: #fff;
    --q-bg: var(--q-primary);
  }
  .bg-primary.mw-form-v2-btn-next-cs {
      background: var(--q-fb-next-colors-primary) !important;
      border: 1px solid var(--q-fb-next-colors-border) !important;
      color: var(--q-fb-next-colors-text) !important;
  }
  .bg-primary.mw-form-v2-btn-next-cs:hover {
    background: var(--q-fb-next-colors-hover) !important;
    border: 1px solid var(--q-fb-next-colors-hover_border) !important;
    color: var(--q-fb-next-colors-text_hover) !important;
  }
  .bg-primary.mw-form-v2-btn-next-cs .q-focus-helper {
    opacity:0 !important;
  }

  .bg-primary.mw-form-v2-btn-back-cs {
    background: var(--q-fb-back-colors-primary) !important;
    border: 1px solid var(--q-fb-back-colors-border) !important;
    color: var(--q-fb-back-colors-text) !important;
  }
  .bg-primary.mw-form-v2-btn-back-cs:hover {
    background: var(--q-fb-back-colors-hover) !important;
    border: 1px solid var(--q-fb-back-colors-hover_border) !important;
    color: var(--q-fb-back-colors-text_hover) !important;
  }
  .bg-primary.mw-form-v2-btn-back-cs .q-focus-helper {
    opacity:0 !important;
  }


  .bg-primary.mw-form-v2-btn-cs {
    background: var(--q-fb-button-colors-primary) !important;
    border: 1px solid var(--q-fb-button-colors-border) !important;
    color: var(--q-fb-button-colors-text) !important;
  }
  .bg-primary.mw-form-v2-btn-cs:hover {
    background: var(--q-fb-button-colors-hover) !important;
    border: 1px solid var(--q-fb-button-colors-hover_border) !important;
    color: var(--q-fb-button-colors-text_hover) !important;
  }

  .bg-primary.mw-form-v2-btn-cs-active{
    background: var(--q-fb-button-colors-active) !important;
    border: 1px solid var(--q-fb-button-colors-border) !important;
    color: var(--q-fb-button-colors-text) !important;
  }

  .bg-primary.mw-form-v2-btn-cs .q-focus-helper {
    opacity:0 !important;
  }

  .bg-login {
    background: var(--q-bg) !important;
  }

</style>
